import {
    Icon, Pagination, Radio, RadioGroup, RadioButton, Button, Divider, Card
} from 'element-ui'
const element = {
    install: function (Vue) {
        Vue.use(Icon);
        Vue.use(Pagination)
        Vue.use(Radio);
        Vue.use(RadioGroup);
        Vue.use(RadioButton);
        Vue.use(Button)
        Vue.use(Divider)
        Vue.use(Card)
    }
}
export default element